var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"aa7f494aa72f9bc081359aa905b4a3d93ec1f0af"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["javascript-nextjs@the-cumin-club"]={id:"aa7f494aa72f9bc081359aa905b4a3d93ec1f0af"};
      